export default [
  {
    text: 'category.table.name',
    value: 'name',
  },
  {
    text: 'category.table.visible',
    value: 'visible',
    type: 'slot',
  },
  {
    text: 'article.table.availableHours',
    value: 'availableHours',
    type: 'slot',
  },
];
